import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import handleOpenWhatsApp from 'services/whatsappService';
import { LEGALMENTE_LOGO_SRC } from '../brandAssets';
import { legalmenteForegroundOnPage } from '../legalmenteReadableText';

const AreYouReady = () => {
  const theme = useTheme();
  const headingColor = legalmenteForegroundOnPage(theme);
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        component={Typography}
        sx={{
          fontWeight: 700,
          fontFamily: 'Georgia, "Times New Roman", serif',
          color: headingColor,
        }}
        variant="h2"
        gutterBottom
        align="center"
        marginBottom="2rem"
      >
        Construyamos la protección legal de las familias, juntos.
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant="h4"
        gutterBottom
        align="center"
        marginBottom="2rem"
        color="textSecondary"
      >
        Reserve su espacio y alinee su marca con la ética, la educación y los valores que la audiencia valora en
        TNO Network.
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems="center" xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography variant="h5" color="textPrimary" sx={{ fontWeight: 700 }}>
                Asocie su marca a la seguridad y al bienestar familiar — autoridad legal, alcance digital y prestigio
                en un entorno brand safe.
              </Typography>
            </Box>
            <Box marginBottom={2}>
              <Typography variant="body2" color="textSecondary" component="div">
                <strong>Teléfono:</strong>{' '}
                <Link
                  href="tel:+584123213439"
                  sx={{ color: headingColor, '&:hover': { color: theme.palette.secondary.main } }}
                >
                  (+58) 412-3213439
                </Link>
                <br />
                <strong>Correo:</strong>{' '}
                <Link
                  href="mailto:legalmenteenfamilia@gmail.com"
                  sx={{ color: headingColor, '&:hover': { color: theme.palette.secondary.main } }}
                >
                  legalmenteenfamilia@gmail.com
                </Link>
                <br />
                <strong>Instagram:</strong>{' '}
                <Link
                  href="https://www.instagram.com/legalmenteenfamilia/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: headingColor, '&:hover': { color: theme.palette.secondary.main } }}
                >
                  @legalmenteenfamilia
                </Link>{' '}
                ·{' '}
                <Link
                  href="https://www.instagram.com/tnonetwork/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: headingColor, '&:hover': { color: theme.palette.secondary.main } }}
                >
                  @tnonetwork
                </Link>
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'flex-start' }}
            >
              <Button
                component="a"
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMd ? false : true}
                onClick={handleOpenWhatsApp}
                target="_blank"
              >
                Patrocinar Legalmente en Familia
              </Button>
              <Box marginTop={{ xs: 2, sm: 0 }} marginLeft={{ sm: 2 }} width={{ xs: '100%', md: 'auto' }}>
                <Button
                  component="a"
                  href="https://www.tnonetwork.com"
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={isMd ? false : true}
                >
                  TNO Network
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
            <Box
              height="100%"
              width="100%"
              maxHeight={600}
              minHeight={{ xs: 280, md: 360 }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                border: `2px solid ${theme.palette.secondary.main}`,
                borderRadius: 2,
                bgcolor: theme.palette.primary.main,
                py: 4,
                px: 3,
              }}
            >
              <Box
                component="img"
                src={LEGALMENTE_LOGO_SRC}
                alt="Legalmente en Familia — logo oficial"
                sx={{
                  width: '100%',
                  maxWidth: 400,
                  maxHeight: 480,
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Legalmente en Familia — Derechos que unen, leyes que protegen.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
